module.exports = __webpack_public_path__ + "static/media/team-mob1.15ed079f.webp";